import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectUserHasPermission } from 'services/usersMe/selectors';
import { AppState } from 'services/types';
import { Roles } from './types';

type Element = React.ReactElement | null;
interface OwnProps {
    children: Element | Element[];
    requiredRoles: Roles[];
    fallback?: React.ReactElement;
}

interface ConnectedProps {
    userHasPermission?: boolean;
}

export type Props = OwnProps & ConnectedProps;

export class RoleGate extends React.PureComponent<Props> {
    render(): Element | Element[] {
        const { userHasPermission, children, fallback } = this.props;

        if (userHasPermission) {
            return children;
        }

        if (fallback) {
            return fallback;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    userHasPermission: makeSelectUserHasPermission()
});

export default connect(mapStateToProps)(RoleGate);
